import React from 'react';
import { motion } from 'framer-motion';
export function IntroducingNerva() {
  return <section className="bg-beige/40 py-16 sm:py-24 my-16 border-y border-taupe/20" data-id="element-204">
      <div className="max-w-5xl mx-auto px-4" data-id="element-205">
        <div className="max-w-article mx-auto text-center mb-12" data-id="element-206">
          <span className="inline-block text-[11px] font-bold uppercase tracking-widest text-sage mb-4 px-3 py-1 bg-white rounded-full shadow-sm" data-id="element-207">
            Now Available · Rylte Health
          </span>
          <h2 className="text-3xl sm:text-5xl font-serif font-medium text-forest leading-tight mb-6" data-id="element-208">
            Nerva™ by Rylte <br className="hidden sm:block" data-id="element-209" />
            <span className="text-sage" data-id="element-210">
              Targeted Cervical Vagal Restoration
            </span>
          </h2>
          <p className="text-lg text-ink/80 leading-relaxed" data-id="element-211">
            The first at-home transcutaneous cervical VNS device engineered
            specifically for gut dysfunction, disrupted sleep, and nervous
            system dysregulation — with named clinical evidence, a 60-day
            guarantee, and no subscription. Ever.
          </p>
        </div>

        <motion.div className="rounded-2xl overflow-hidden shadow-md bg-white max-w-4xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-212">
          <img src="https://cdn.magicpatterns.com/uploads/3fQc4T6WkDaTsq6GfR3nV6/hf_20260522_090546_a737ce34-bdd6-4dd1-923c-4de062bbf53b.png" alt="The Nerva cervical VNS device resting on a linen-covered side table in warm natural light, beside a glass of water and a ceramic mug" className="w-full h-[360px] sm:h-[480px] md:h-[560px] object-cover object-center" data-id="element-213" />
        </motion.div>

        <div className="max-w-article mx-auto" data-id="element-214">
          <p className="text-lg text-ink/80 leading-relaxed mb-6" data-id="element-215">
            Nerva™ is a transcutaneous cervical vagus nerve stimulator. A
            small, discreet wearable device — placed against the neck for 10
            minutes per day — delivers a precisely-calibrated electrical signal
            through the skin to the vagus nerve at the carotid triangle,
            activating the cervical vagal pathway and restoring the upstream
            signal that your gut, your inflammation, your sleep, and your
            nervous system have been missing.
          </p>
          <p className="text-lg font-medium text-forest text-center bg-white py-4 px-6 rounded-xl shadow-sm border border-taupe/20" data-id="element-216">
            One device. One daily session. No subscription. No prescription. No
            surgery. No tongue device. No all-day wear requirement.
          </p>
        </div>
      </div>
    </section>;
}